export default __webpack_public_path__ + "static/0133-21306b4daf609854a957284552b7357b.png";